import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import PropTypes from 'prop-types';
import { withIcon } from '../Icon';
export var GlobeOutlineSvg = function GlobeOutlineSvg(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M16 2a14 14 0 1014 14A14 14 0 0016 2zm1 7V4.06h.75c.37.06.75.13 1.12.22h.18A11.62 11.62 0 0121.84 9zm-6.84 0A11.62 11.62 0 0113 4.41h.18c.37-.09.75-.16 1.12-.22h.75V9zM24 9a17.91 17.91 0 00-1.24-2.94 12.05 12.05 0 013 2.94zM6.27 9a12.05 12.05 0 013-2.94A17.91 17.91 0 008.05 9zM25 15a24.17 24.17 0 00-.49-4h2.41A12 12 0 0128 15zm-8 0v-4h5.43a22.18 22.18 0 01.57 4zm-8 0a22.18 22.18 0 01.53-4H15v4zm-5 0a12 12 0 011.06-4h2.46A24.17 24.17 0 007 15zm20.43 6a24.17 24.17 0 00.57-4h3a12 12 0 01-1.06 4zM17 21v-4h6a22.18 22.18 0 01-.53 4zm-7.43 0A22.18 22.18 0 019 17h6v4zm-4.46 0a12 12 0 01-1.06-4H7a24.17 24.17 0 00.49 4zm17.6 4.94A17.91 17.91 0 0024 23h1.78a12.05 12.05 0 01-3 2.94zm-5.71 2V23h4.84a11.62 11.62 0 01-2.79 4.59l-.18.05c-.37.09-.75.16-1.12.22l-.33.05H17zm-2 0h-.42l-.33-.05c-.37-.06-.75-.13-1.12-.22l-.13-.08A11.62 11.62 0 0110.16 23H15v4.94zm-5.71-2a12.05 12.05 0 01-3-2.94h1.76a17.91 17.91 0 001.24 2.94z"
  }));
};
GlobeOutlineSvg.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
GlobeOutlineSvg.defaultProps = {
  children: /*#__PURE__*/React.createElement("title", null, "Globe")
};
export default withIcon(GlobeOutlineSvg);